import { Breadcrumb } from "react-bootstrap";
import styled from "styled-components";

export interface BreadcrumbItem {
  value?: any;
  label: string;
  id?: string | number;
}

interface BreadCrumbsProps {
  items: BreadcrumbItem[];
  onBreadcrumbClick: (value: any, index: number) => void;
}

const StyledBreadcrumb = styled(Breadcrumb)`
  ol {
    margin-block-end: 0;
  }
`;

const BreadCrumbs = ({ items, onBreadcrumbClick }: BreadCrumbsProps) => {
  return (
    <StyledBreadcrumb>
      {items.map((item, index) => {
        return (
          <Breadcrumb.Item
            className="mb-0"
            key={index}
            active={index === items.length - 1}
            onClick={() => onBreadcrumbClick(item.value, index)}
            value={item.value}
          >
            {item.label}
          </Breadcrumb.Item>
        );
      })}
    </StyledBreadcrumb>
  );
};

export default BreadCrumbs;
